import { useCallback, useState } from 'react';

interface SaveConfigModalState {
  isOpen: boolean;
  config?: string;
  defaultOption?: 'existing' | 'new';
  disableOptions?: boolean;
}

const InitialSaveConfigModalState: SaveConfigModalState = {
  isOpen: false,
  config: '',
};
export const useSaveConfigModal = () => {
  const [saveConfigModalState, setSaveConfigModalState] =
    useState<SaveConfigModalState>(InitialSaveConfigModalState);
  const [error, setError] = useState<string | null>(null);

  const onClose = useCallback(() => {
    setSaveConfigModalState(InitialSaveConfigModalState);
  }, []);

  const onOpen = useCallback((isNewConfig: boolean, configName?: string) => {
    setSaveConfigModalState({
      isOpen: true,
      config: configName,
      defaultOption: isNewConfig ? 'new' : undefined,
      disableOptions: isNewConfig,
    });
  }, []);

  return {
    configModalState: saveConfigModalState,
    onClose,
    onOpen,
    error,
    setError,
  };
};
